"use strict";
var $ = require("../internals/export");
var $reduce = require("../internals/array-reduce").left;
var arrayMethodIsStrict = require("../internals/array-method-is-strict");
var CHROME_VERSION = require("../internals/environment-v8-version");
var IS_NODE = require("../internals/environment-is-node");
var CHROME_BUG = !IS_NODE && CHROME_VERSION > 79 && CHROME_VERSION < 83;
var FORCED = CHROME_BUG || !arrayMethodIsStrict("reduce");
$({ target: "Array", proto: true, forced: FORCED }, {
  reduce: function reduce(callbackfn) {
    var length = arguments.length;
    return $reduce(this, callbackfn, length, length > 1 ? arguments[1] : void 0);
  }
});
